import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import {
  devicePixelRatio,
  ckeInlineConfig,
  DefaultLanguageId,
  FooterMenuComponents,
  footerMenu,
} from "src/app/shared/constants";
import { Container } from "src/app/shared/model/container.models";
import { CommonHttpService } from "src/app/shared/services/common-http/common-http.service";
import { PlaybookCommunicationService } from "../shared/services/playbook-communication.service";
import { ActivatedRoute, Router } from "@angular/router";
import { isNull, reject } from "lodash";
import { UtilService } from "../shared/services/utils/util.service";
import { isFirefox, isEdge } from '../../shared/utils/browser.util';
import { LocalStorageService } from "ngx-webstorage";
import { DeviceDetectorService } from "ngx-device-detector";
import { mobileFooterMenuLists } from "src/app/shared/constants";
import { SearchPlaybookComponent } from "projects/playbook-viewer/src/app/playbook-viewer/search-playbook/search-playbook.component";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { Modalconfig } from "src/app/shared/constants";
import { Playbook } from "src/app/shared/model/playbook.models";
import { PlaybookCommunicationService as PlaybookViewerCommService } from "projects/playbook-viewer/src/app/playbook-viewer/shared/services/playbook-communication.service";
import { CommunicationService } from "src/app/shared/services/communication/communication.service";
import { Company } from "src/app/shared/interfaces/company";
import { SessionStorageService } from "src/app/shared/services/session-storage/session-storage.service";
import {
  profileRoles,
  sessionProfile,
} from "src/app/shared/interfaces/sessionStorageModel";
import { ConfirmationModelComponent } from "src/app/shared/components/confirmation-model/confirmation-model.component";
import { Subscription } from "rxjs";
import { MessageService } from "src/app/shared/services/message/message.service";
@Component({
    selector: "app-container-content",
    templateUrl: "./container-content.component.html",
    styleUrls: ["./container-content.component.scss"],
    standalone: false
})
export class ContainerContentComponent implements OnInit {
  @Input("Container") container;
  @Input("pageTemplateId") pageTemplateId = null;
  @Input() isDraftMode = false;
  @Input() videoListPerSection;
  inMobileEditor: boolean = false;
  hideContent: boolean = false;
  reorderContent: boolean = false;
  @Output() tabChange: EventEmitter<any> = new EventEmitter();
  @Output() ratingModalOpen: EventEmitter<any> = new EventEmitter();
  devicePixelRatio = devicePixelRatio;
  config;
  languageId: number;
  defaultLanguageId = DefaultLanguageId;
  public isFireFox = isFirefox();
  public isEdge = isEdge();
  hiddenContList: Container[] = [];
  deviceInfo = null;
  isMobile: boolean = false;
  isDesktopDevice: boolean;
  footerMenuLists: Array<footerMenu> = mobileFooterMenuLists;
  displayFooterMenus = [];
  playbookId;
  isVideoPlaylist = false;
  videoPlaylist = [];
  companyId;
  private bsModalSearchPlaybook: BsModalRef;
  playbook: Playbook;
  company: Company;
  loggedInUserRole: string;
  vPlaybookManagerId: number;
  hasReps = false;
  userId: number;
  confirmationModalRef: BsModalRef;
  confModalSubsciber: Subscription;
  profileData: sessionProfile;
  searchText: string = "";

  constructor(
    private commonHttpService: CommonHttpService,
    private commService: PlaybookCommunicationService,
    private activatedRoute: ActivatedRoute,
    private utilService: UtilService,
    private localSt: LocalStorageService,
    private deviceService: DeviceDetectorService,
    private messageService: MessageService,
    private modalService: BsModalService,
    private viewerCommService: PlaybookViewerCommService,
    private communicationService: CommunicationService,
    private sessionStorageService: SessionStorageService,
    private router: Router
  ) {
    this.config = ckeInlineConfig;
    this.deviceService.setDeviceInfo(window.navigator.userAgent);
    this.checkDeviceType();

    activatedRoute.queryParams.subscribe((qp) => {
      const searchText = qp["searchText"];
      this.searchText = searchText ? searchText : "";
    });
  }

  checkDeviceType() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isDesktopDevice = this.deviceService.isDesktop();
  }

  ngOnInit() {
    this.languageId =
      +this.activatedRoute.snapshot.queryParams.languageId ||
      this.defaultLanguageId;
    this.playbookId = +this.activatedRoute.snapshot.params.playbookId;
    this.companyId = this.commService.Playbook.companyId;
    this.viewerCommService.Playbook = this.commService.Playbook;
    this.company = this.communicationService.getSessionStoredCompany("company");
  }

  setShowHideMobileContent() {
    this.hidePlaybookContent(
      this.localSt.retrieve("isShowHide") &&
        window !== window.parent &&
        window.location == window.parent.location
    );
    this.localSt.observe("isShowHide").subscribe((hideContent) => {
      if (
        window !== window.parent &&
        window.location == window.parent.location
      ) {
        this.hidePlaybookContent(hideContent);
      }
    });
  }
  setReoderMobileContent() {
    this.reorderPlaybookContent(
      this.localSt.retrieve("isReorder") &&
        window !== window.parent &&
        window.location == window.parent.location
    );
    this.localSt.observe("isReorder").subscribe((reorderContent) => {
      if (
        window !== window.parent &&
        window.location == window.parent.location
      ) {
        this.reorderPlaybookContent(reorderContent);
      }
    });
  }

  getUserClaims() {
    this.profileData = this.sessionStorageService.getLoggedInProfileDetail();
    if (this.profileData) {
      this.loggedInUserRole = this.profileData.role;
      this.vPlaybookManagerId = this.profileData.vPlaybookManagerId;
      this.userId = this.profileData.id;
    }
    if (
      this.loggedInUserRole === profileRoles.salesManager &&
      (this.company.hasCoachingAccess ||
        this.company.enableLearningCenterAccess)
    ) {
      this.commonHttpService
        .get({
          uri: `/api/Challenge/GetAllReps?managerId=${this.userId}&companyId=${this.companyId}`,
        })
        .subscribe((repsArray: any[]) => {
          this.hasReps = repsArray.length > 0;
        });
    }
  }

  hidePlaybookContent(hideContent) {
    this.hideContent = hideContent;
  }

  reorderPlaybookContent(reorderContent) {
    this.reorderContent = reorderContent;
  }

  getMobileFooterList() {
    if (
      this.isMobile ||
      (window !== window.parent && window.location == window.parent.location)
    ) {
      this.commonHttpService
        .get({
          uri: `/api/PlaybookMobileView/GetPlaybookFooterItems/${this.playbookId}?companyId=${this.companyId}`,
        })
        .subscribe((res: any) => {
          this.updateFooterContent(res);
        });
    }
    if (window !== window.parent && window.location == window.parent.location) {
      this.localSt
        .observe("footerContent")
        .subscribe((enabledFooterContent) => {
          if (enabledFooterContent && enabledFooterContent.length) {
            this.updateFooterContent(enabledFooterContent);
          }
        });
    }
  }

  updateFooterContent(footerContent: Array<footerMenu>) {
    this.footerMenuLists = JSON.parse(JSON.stringify(mobileFooterMenuLists));
    this.footerMenuLists.forEach((footerMenu) => {
      footerContent.forEach((menuItem) => {
        if (footerMenu.menu === menuItem.menu) {
          footerMenu.enabled = menuItem.enabled;
          footerMenu.order = menuItem.order;
        }
      });
    });
    this.footerMenuLists.sort((a, b) => a.order - b.order);
    this.displayFooterMenus = this.footerMenuLists.filter(
      (footerMenu) => footerMenu.enabled
    );
    if (!this.videoListPerSection.length) {
      this.displayFooterMenus = this.displayFooterMenus.filter(
        (footerMenu) => footerMenu.menu !== FooterMenuComponents.videos
      );
    }
    if (
      !this.company.hasCoachingAccess ||
      [
        profileRoles.playbookOwner,
        profileRoles.vPlaybookReader,
        profileRoles.companyReader,
        profileRoles.specificVPlaybookAdmin,
      ].includes(this.profileData.role)
    ) {
      this.displayFooterMenus = this.displayFooterMenus.filter(
        (footerMenu) => footerMenu.menu !== FooterMenuComponents.coaching
      );
    }
    if (
      !this.company.enableLearningCenterAccess ||
      [
        profileRoles.playbookOwner,
        profileRoles.vPlaybookReader,
        profileRoles.companyReader,
        profileRoles.specificVPlaybookAdmin,
      ].includes(this.profileData.role)
    ) {
      this.displayFooterMenus = this.displayFooterMenus.filter(
        (footerMenu) => footerMenu.menu !== FooterMenuComponents.lms
      );
    }
  }

  // changeRow

  menuClicked(footerMenuClicked: footerMenu, index) {
    switch (footerMenuClicked.menu) {
      case FooterMenuComponents.home:
      case FooterMenuComponents.coaching:
      case FooterMenuComponents.lms: {
        // go to playbook home/coaching/lms page
        this.checkStorageData(footerMenuClicked);
        break;
      }
      case FooterMenuComponents.ratings: {
        // open ratings modal
        this.openRatingsModalFunc();
        break;
      }
      case FooterMenuComponents.search: {
        // open search playbook modal
        if (
          window === window.parent ||
          (window != window.parent && window.location != window.parent.location)
        ) {
          this.searchClick();
        } else {
          this.messageService.showInfoMessage(
            "Search is disabled for mobile editor"
          );
        }
        break;
      }
      case FooterMenuComponents.supportMail: {
        // open mail to
        this.openSupportMail();
        break;
      }
      case FooterMenuComponents.videos: {
        // open video playlist page
        this.isVideoPlaylist = !this.isVideoPlaylist;
        if (this.isVideoPlaylist) {
          this.displayFooterMenus[index].title = "Playbook";
          this.displayFooterMenus[index].icon =
            "assets/img/mobileEditorIcons/book.png";
        } else {
          this.displayFooterMenus[index].title = "Videos";
          this.displayFooterMenus[index].icon =
            "assets/img/mobileEditorIcons/videos.png";
        }
        this.localSt.store("isVideoPlaylist", this.isVideoPlaylist);
        break;
      }
      default:
        break;
    }
  }

  checkStorageData(footerMenu) {
    const mobilePlaybookRows =
      JSON.parse(localStorage.getItem("mobilePlaybookRow")) || [];
    const hiddenContainers =
      JSON.parse(localStorage.getItem("hiddenContainers")) || [];
    const hiddenContentRows =
      JSON.parse(localStorage.getItem("hiddenContentRows")) || [];
    if (
      mobilePlaybookRows.length ||
      hiddenContainers.length ||
      hiddenContentRows.length
    ) {
      const initialState = {
        msg: "You have some unsaved data in the current playbook. Do you want to save these data?",
      };
      this.confirmationModalRef = this.modalService.show(
        ConfirmationModelComponent,
        Object.assign({ initialState }, { class: "custom-modal" }, Modalconfig)
      );
      this.confModalSubsciber =
        this.confirmationModalRef.content.onclose.subscribe(
          (isSaveData: boolean) => {
            if (isSaveData) {
              this.saveUnsavedData(
                mobilePlaybookRows,
                hiddenContainers,
                hiddenContentRows,
                footerMenu
              );
            }
            this.confirmationModalRef.hide();
            this.confModalSubsciber.unsubscribe();
          }
        );
    } else {
      this.goToUrl(footerMenu);
    }
  }

  saveUnsavedData(
    mobilePlaybookRows,
    hiddenContainers,
    hiddenContentRows,
    footerMenu
  ) {
    if (mobilePlaybookRows.length) {
      this.commonHttpService
        .post({
          uri: `/api/PlaybookMobileView/ReOrderPlaybookContent`,
          object: {
            playbookId: this.playbookId,
            contentColumns: mobilePlaybookRows,
          },
          message: {
            errorMessage: "Something went wrong. Please try again.",
          },
        })
        .subscribe(() => {
          localStorage.setItem("mobilePlaybookRow", null);
          this.localSt.store("isReorder", false);
          this.goToUrl(footerMenu);
        });
    }

    let contentRows = [];
    let sections = [];
    if (hiddenContentRows.length) {
      contentRows = hiddenContentRows.map((contentRow) => ({
        id: contentRow.id,
        isHide: contentRow.isHidden,
      }));
    }
    if (hiddenContainers.length) {
      sections = hiddenContainers.map((container) => ({
        id: container.id,
        isHide: container.isHidden,
      }));
    }
    if (contentRows.length || sections.length) {
      this.commonHttpService
        .post({
          uri: `/api/PlaybookMobileView/HidePlaybookContent`,
          object: {
            playbookId: this.playbookId,
            contentRows: contentRows,
            sections: sections,
          },
        })
        .subscribe(() => {
          localStorage.setItem("hiddenContainers", null);
          localStorage.setItem("hiddenContentRows", null);
          this.localSt.store("isShowHide", false);
          this.goToUrl(footerMenu);
        });
    }
  }

  goToUrl(footerMenu) {
    if (footerMenu.menu === FooterMenuComponents.home) {
      window.location.href = localStorage.getItem("companyUrlEditor");
    } else if (footerMenu.menu === FooterMenuComponents.coaching) {
      window.location.href = this.getCoachingRouterLink();
    } else if (footerMenu.menu === FooterMenuComponents.lms) {
      window.location.href = this.getLmsRouterLink();
    }
    this.localSt.store("isVideoPlaylist", false);
  }

  openRatingsModalFunc() {
    this.ratingModalOpen.emit();
  }

  /**
   * To trigger search playbook modal
   */
  searchClick() {
    if (this.searchText) {
      this.activatedRoute.queryParams.subscribe((qp) => {
        this.router.navigate(["."], {
          relativeTo: this.activatedRoute,
          queryParams: { ...qp, searchText: null },
        });
      });

      return;
    }
    const initialState = {
      companyId: this.companyId,
      playbookId: this.playbookId,
    };
    this.bsModalSearchPlaybook = this.modalService.show(
      SearchPlaybookComponent,
      Object.assign({ initialState }, { class: "custom-modal " }, Modalconfig)
    );
  }

  /**
   * To open mail for playbook support
   */
  openSupportMail() {
    window.open("mailto:support@vplaybook.com", "_blank");
  }

  /**
   * Get router link as per role and module
   *
   * @param routingModule Name of module to switch
   */
  getCoachingRouterLink(routingModule: string = "dashboard"): string {
    if (this.getUserRoleIndex === 4) {
      return;
    }
    const verb = ["admin", "manager", "manager", "rep"][this.getUserRoleIndex];

    const routesObject = {
      admin: {
        dashboard: "challenges/dashboard",
      },
      manager: {
        dashboard: "coachingdashboard",
      },
      rep: {
        dashboard: "coachingdashboardrep",
      },
    };

    return `company/${this.companyId}/${verb}/${routesObject[verb][routingModule]}`;
  }

  /**
   * Get user access level
   *
   * Return value:
   * Admin -> 0
   * Manager -> 1
   * Manager & Rep -> 2
   * Reps -> 3
   * NOTA -> 4
   */
  get getUserRoleIndex() {
    switch (this.loggedInUserRole) {
      case "SuperVPlaybookAdmin":
      case "StandardVPlaybookAdmin":
      case "Administrator":
        return 0;

      case "SalesManager":
        return this.vPlaybookManagerId ? (this.hasReps ? 2 : 3) : 1;

      case "User":
        return 3;

      default:
        return 4;
    }
  }

  /**
   * Get router link as per role and module
   *
   * @param routingModule Name of module to switch
   */
  getLmsRouterLink(
    routingModule: string = "dashboard",
    asUser = false
  ): string {
    if (this.getUserRoleIndex === 4) {
      return;
    }
    let internalRoleIndex = this.getUserRoleIndex;

    if (asUser) {
      internalRoleIndex = 3;
    }

    const verb = ["admin", "manager", "manager", "user"][internalRoleIndex];

    const routesObject = {
      admin: {
        dashboard: "dashboard",
      },
      manager: {
        dashboard: "dashboard",
      },
      user: {
        dashboard: "dashboard",
      },
    };

    return `company/${this.companyId}/lc/${verb}/${routesObject[verb][routingModule]}`;
  }

  showHideSectionAlert(cont: Container) {
    const initialState = {
      msg: "Are you sure you want to hide this entire section of content?",
    };
    this.confirmationModalRef = this.modalService.show(
      ConfirmationModelComponent,
      Object.assign({ initialState }, { class: "custom-modal" }, Modalconfig)
    );
    this.confModalSubsciber =
      this.confirmationModalRef.content.onclose.subscribe(
        (isHideSection: boolean) => {
          if (isHideSection) {
            this.showContainer(cont);
          }
          this.confirmationModalRef.hide();
          this.confModalSubsciber.unsubscribe();
        }
      );
  }

  showContainer(cont: Container) {
    // Are you sure you want to hide this entire section of content?
    cont.isHidden = true;
    try {
      this.hiddenContList =
        JSON.parse(localStorage.getItem("hiddenContainers")) || [];
      if (this.hiddenContList.length) {
        let contInList = false;
        this.hiddenContList.forEach((hiddenCont) => {
          if (hiddenCont.id === cont.id) {
            hiddenCont.isHidden = true;
            contInList = true;
          }
        });
        if (!contInList) {
          this.hiddenContList.push(cont);
        }
        localStorage.setItem(
          "hiddenContainers",
          JSON.stringify(this.hiddenContList)
        );
      } else {
        this.hiddenContList.push(cont);
        localStorage.setItem(
          "hiddenContainers",
          JSON.stringify(this.hiddenContList)
        );
      }
    } catch (e) {
      console.log(e);
    }
  }

  hideContainer(cont: Container) {
    cont.isHidden = false;
    try {
      this.hiddenContList =
        JSON.parse(localStorage.getItem("hiddenContainers")) || [];
      if (this.hiddenContList.length) {
        let contInList = false;
        this.hiddenContList.forEach((hiddenCont) => {
          if (hiddenCont.id === cont.id) {
            hiddenCont.isHidden = false;
            contInList = true;
          }
        });
        if (!contInList) {
          this.hiddenContList.push(cont);
        }
        localStorage.setItem(
          "hiddenContainers",
          JSON.stringify(this.hiddenContList)
        );
      } else {
        this.hiddenContList.push(cont);
        localStorage.setItem(
          "hiddenContainers",
          JSON.stringify(this.hiddenContList)
        );
      }
    } catch (err) {
      console.log(err);
    }
  }

  changeTabFunc(event) {
    this.tabChange.emit(event);
  }

  /**
   * To update section when any contentblock gets deleted
   * @param container updated container from API response
   */
  updateSection(container) {
    this.container.containers = reject(this.container.containers, (cont) => {
      return cont.id === container.id;
    });
    this.container.containers.push(container);
  }

  // To show menu for for title edit
  titleFocus(cont) {
    const menu = $(`#container-menu-${cont.id}`);
    menu.show();
    menu.css({
      width:
        $(`#editor-title-${cont.id}`).closest("article.content").width() + "px",
    });
  }

  /**
   * To update section title
   * @param event Ckeditor emmited event
   * @param container Container for changing title
   */
  updateSectionTitle(event, container: Container) {
    const editorData = event.editor.getData().trim().replaceAll("\u000B", " ");
    $(".text-editor-menu-bar").hide();
    if (
      isNull(container.title) ||
      container.title.localeCompare(event.editor.getData().trim()) !== 0
    ) {
      const reqObj = {
        id: container.id,
        title: editorData,
        playbookId: container.playbookId,
        isDraftMode: this.isDraftMode,
        iconClass: container.iconClass,
        customIconAssetId: container.customIconAssetId,
        type: container.type,
        parentContainerId: container.parentContainerId,
        isShaded: container.isShaded,
        previewImageId: container.previewImageId,
        conversationTemplateId: container.conversationTemplateId,
        companyId: this.commService.Playbook.companyId,
        languageId: this.languageId,
        pageTemplateId: this.pageTemplateId,
      };
      this.commonHttpService
        .putWithHeaders(
          {
            uri: "/api/Containers/UpdateContainer",
            object: reqObj,
          },
          {
            languageId: this.languageId,
            playbookId: container.playbookId,
            pageId: container.parentContainerId,
            sectionId: container.id,
            isdraftmode: this.container.isCurrentPageInDraftMode,
          }
        )
        .subscribe((res) => {
          container.title = editorData;
          event.editor.setData(container.title);
        });
    } else {
      event.editor.setData(container.title);
    }
  }
  /**
   * To set section header image if available
   */
  getPreviewImage(previewImageKey) {
    return previewImageKey
      ? `/api/Assets/Image/${previewImageKey}?height=100&ratio=${this.devicePixelRatio}`
      : "";
  }

  onDragover1(e: DragEvent) {
    if (this.isFireFox || this.isEdge) {
      this.utilService.clearAllBorderClasses();
    }
  }
}
